import React from 'react'

export interface TranslationContextValue {
  lang: string
  __: (key: string, ...args: (string | number)[]) => string
}

const TranslationContext = React.createContext<TranslationContextValue>({
  lang: 'en',
  __: (key, ..._args) => key
})

export default TranslationContext
